/* unplugin-vue-components disabled */import script from "./testList.vue?vue&type=script&lang=ts&setup=true"
export * from "./testList.vue?vue&type=script&lang=ts&setup=true"

import "./testList.vue?vue&type=style&index=0&id=6f874088&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f874088"]])

export default __exports__